// extracted by mini-css-extract-plugin
export default {"flag":"PriorityFlag_flag__wWqYR","high":"PriorityFlag_high__Apwf9","medium":"PriorityFlag_medium__1fxGB","low":"PriorityFlag_low__8szre"};